import { render, staticRenderFns } from "./CommandLogButton.vue?vue&type=template&id=2bb473c0&"
import script from "./CommandLogButton.vue?vue&type=script&lang=js&"
export * from "./CommandLogButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports